import React, { FC } from "react";
import { Button, Dialog, Typography } from "@earned/core";
import { TaskManagerModalType } from "@modules/advisor/types";
interface RemoveTaskModalProps {
  modalType: TaskManagerModalType;
  onClose: () => void;
  onConfirm: () => void;
}

const RemoveTaskModal: FC<RemoveTaskModalProps> = ({
  modalType,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog isOpen={modalType !== null} onClose={onClose} title="Delete Task">
      <div className="rounded-lg bg-white">
        <div className="items-center justify-center">
          <Typography variant="body" color="primary">
            {modalType === "bulk"
              ? "Are you sure you want to delete these tasks?"
              : "Are you sure you want to delete this task?"}
          </Typography>
        </div>
        <div className="flex flex-row justify-end space-x-2 pt-10">
          <Button variant="tertiary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            Delete
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default RemoveTaskModal;
